// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"144":"dd004bd5","798":"169f0014","860":"ec075daa"}[chunkId] + ".chunk.css";
};